



















































































import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { List } from 'linqts'
import moment from "moment";

// Servicios
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import { toastService } from '@/services/ToastService';
import GenericService from '@/services/GenericService';
import GenericStore from '@/services/GenericStore';

import SorteoPopup from './SorteoPopup.vue';
import DialogForm from "@/components/DialogForm.vue";
import DialogConfirm from "@/components/DialogConfirm.vue";
import { Sorteo } from '@/model/Sorteo';


@Component({
  components: {
    DialogForm,
    DialogConfirm
  },
})
export default class SorteoList extends Vue {
  visible: boolean = false;
  nameComponent: string = "SorteoPopup";
  tituloPopup: string = "Nuevo Sorteo";
  saveEventForm: string ="Sorteo-DialogForm-Save";
  closeEventForm: string ="Sorteo-DialogForm-Close";
  
  visibleConfirm: boolean = false;
  cancelEventConfirm: string ="Sorteo-DialogConfirm-Cancel";
  acceptEventConfirm: string ="Sorteo-DialogConfirm-Accept";
  creating: boolean = false;

  // @Inject('sorteoStore') 
  // sorteoStore: any | GenericStore<Sorteo>;

  sorteoService: any | GenericService<Sorteo> = new GenericService<Sorteo>("Sorteo");

  sorteos: Array<Sorteo> = [];
  sorteosActivos: Array<Sorteo> = [];
  sorteosHistoricos: Array<Sorteo> = [];
  sorteo: any | Sorteo = {};

  destroyed(){
    eventService.off(this.closeEventForm);
    eventService.off("SorteoPopup-Save");
    eventService.off(this.cancelEventConfirm);
    eventService.off(this.acceptEventConfirm);
  }

  created(){
    logService.Info("Inicio","SorteoList.vue - created()");
    let self = this;
    this.load();

    eventService.on(this.closeEventForm, (obj: any) => {
      self.visible = false;
    });

    eventService.on("SorteoPopup-Save", (obj: any) => {
      self.visible = false;
      if(self.creating){
        this.insert(obj);
      }else{
        this.update(obj);
      }
    });

    eventService.on(this.cancelEventConfirm, (obj: any) => {
      this.visibleConfirm = false;
      this.sorteo = {};
    });

    eventService.on(this.acceptEventConfirm, (obj: any) => {
      this.visibleConfirm = false;
      this.delete();
    });
  }

  load(){
    logService.Info("Inicio","SorteoList.vue - load()");
    this.sorteoService.getAll().then((res: any) => {
      this.sorteos = res;
      let listTemp = new List<Sorteo>(this.sorteos);
      let fechaActual = moment();
      this.sorteosActivos = listTemp.Where(x => x !== undefined && fechaActual.isBefore(x.FechaCelebracion)).ToArray();
      this.sorteosHistoricos = listTemp.Where(x => x !== undefined &&  fechaActual.isAfter(x.FechaCelebracion)).ToArray();
    })
  }

  insert(obj: Sorteo){
    logService.Info("Inicio","SorteoList.vue - insert()");
    eventService.emit("LoadPanel", true);
    this.sorteoService.insert(obj).then((res: any) => {
      logService.Info("Sorteo creado correctamente","SorteoList.vue - insert()");
      this.creating = false;
      toastService.success("Sorteo creado correctamente.");
      eventService.emit("LoadPanel", false);
      this.load();
    });
  }

  update(obj: Sorteo){
    logService.Info("Inicio","SorteoList.vue - update()");
    eventService.emit("LoadPanel", true);
    this.sorteoService.update(obj).then((res: any) => {
      logService.Info("Sorteo modificado correctamente","SorteoList.vue - update()");
      this.creating = false;
      toastService.success("Sorteo modificado correctamente.");
      eventService.emit("LoadPanel", false);
      this.load();
    });
  }

  delete(){
    logService.Info("Inicio","SorteoList.vue - delete()");
    eventService.emit("LoadPanel", true);
    this.sorteoService.deleteById(this.sorteo.Id).then(() => {
      logService.Info("Sorteo eliminado correctamente","SorteoList.vue - delete()");
      toastService.success("Sorteo eliminado correctamente.");
      eventService.emit("LoadPanel", false);
      this.load();
    });
  }

  onView(data: any){
    this.$router.push('/sorteo/'+data.Id);
  }

  onNew(){
    this.visible = true;
    this.creating = true;
    eventService.emit('SorteoPopup-Open', new Sorteo())
  }

  onEdit(data: any){
    this.visible = true;
    eventService.emit('SorteoPopup-Open', data)
  }

  onDelete(data: any){
    this.sorteo = data;
    this.visibleConfirm = true;
  }
}
